// src/components/Header/Header.js
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./HeaderMobile.module.css";
import logo from "../../assets/images/logo-metropolis.png";
import ArrowCircleIcon from "../../assets/svgs/arrow-circle.svg";

const HeaderMobile = ({ isAdmin }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAdminClick = () => {
    navigate("/admin");
  };

  const handleUserClick = () => {
    navigate("");
  };

  const isRootPath = location.pathname === "/";
  const isAdminPath = location.pathname === "/admin";
  const isControlHorarioPath = location.pathname === "/control-horario";

  return (
    <header className={styles.header}>
      <nav className={styles.topbar}>
        <div className={styles.wrapperNav}>
          <a href="https://imetropolis.es/mosaico/Cortes.php">
            <img className={styles.logo} src={logo} alt="Logo Metrópolis" />
          </a>

          {isAdmin && (isRootPath || isControlHorarioPath) && (
            <button
              className={styles.adminButton}
              onClick={handleAdminClick}
              aria-label="Cambiar a admin"
            >
              Cambiar a admin
              <img
                src={ArrowCircleIcon}
                alt=""
                className={styles.adminIcon}
              />
            </button>
          )}

          {isAdmin && isAdminPath && (
            <a
              href="/"
              style={{
                textDecoration: "none",
                display: "flex",
                marginLeft: "20px"
              }}
            >
              <button
                className={styles.adminButton}
                onClick={handleUserClick}
                aria-label="Cambiar a usuario"
              >
                Cambiar a usuario
                <img
                  src={ArrowCircleIcon}
                  alt=""
                  className={styles.adminIcon}
                />
              </button>
            </a>
          )}
        </div>
      </nav>
    </header>
  );
};

export default HeaderMobile;
